import { render } from "./modeltwo.vue?vue&type=template&id=bbfc1b36"
import script from "./modeltwo.vue?vue&type=script&lang=js"
export * from "./modeltwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__